import {cloneElement} from 'react'
import utils from '@eitje/utils'
import {t} from '@eitje/bridge'
import {prettyPrintArray} from '@eitje/utils'
import {buildField} from '@eitje/form'
import _ from 'lodash'
import {Layout} from '~/components/layout'
import {Text} from '~/components/text'
import {SelectItemDot} from '../select_item_dot'
import {SelectComponent} from './select_component'

// formatValue can be:
// - function
// - "count" (default): 3 {title}
// - "list": item1, item2 & item3
const _SelectField = ({title, placeholder, trigger, formatValue, readOnly, decorated, ...rest}) => {
	const selectedItems = getSelectedItems(rest)
	const inputValue = defaultFormatValue({title, placeholder, formatValue, selectedItems, ...rest})
	const isPlaceholderShown = inputValue === placeholder
	const selectedItem = selectedItems.length === 1 ? selectedItems[0] : null
	const defaultTrigger = (
		<DefaultSelectTrigger inputValue={inputValue} isPlaceholderShown={isPlaceholderShown} selectedItem={selectedItem} readOnly={readOnly} />
	)
	// On exports/show/columns we want to show a non floating Select without any form field decoration, so we skip the fallback Layout in decorated=false.
	const fallbackTrigger = decorated !== false && defaultTrigger

	if (trigger) trigger = cloneElement(trigger, {title: inputValue})

	if (readOnly) return trigger || defaultTrigger

	return <SelectComponent trigger={trigger || fallbackTrigger} {...rest} />
}

const defaultPickerValue = props => {
	if (props.type == 'single') return null
	return []
}

export const SelectField = buildField(_SelectField, {
	className: 'eitje-select',
	icon: true,
	clearIcon: true,
	defaultPickerValue,
})

function getSelectedItems({items, value, valueField = 'id'}) {
	const valueArr = utils.alwaysArray(value)
	const selectableItems = items.flatMap(item => item.subItems || item)

	return selectableItems.filter(item => valueArr.includes(item[valueField]))
}

function defaultFormatValue({title, formatValue, selectedItems, labelField = 'name', placeholder}) {
	const selectedCount = selectedItems.length

	if (_.isFunction(formatValue)) return formatValue(selectedItems, placeholder)

	if (selectedCount === 1) {
		const selectedItem = selectedItems[0]
		return selectedItem.t ? t(selectedItem.t) : selectedItem[labelField]
	}

	if (selectedCount > 1) {
		if (formatValue === 'list') return prettyPrintArray({array: selectedItems.map(item => item[labelField]), quotes: false, joinWord: '&'})
		return `${selectedCount} ${title}`
	}

	return placeholder
}

const DefaultSelectTrigger = ({inputValue, isPlaceholderShown, selectedItem, readOnly, ref, ...rest}) => {
	return (
		<Layout className="select-trigger-container" tabIndex={0} ref={ref} {...rest} {...(readOnly && {onClick: null})}>
			<SelectItemDot dotColor={selectedItem?.dotColor} />
			<Text className={utils.makeCns('form-field-value-label', isPlaceholderShown && 'form-field-value-placeholder')} truncate>
				{inputValue}
			</Text>
		</Layout>
	)
}
